export enum DeviceTypeEnum {
    ANDROID = 'android',
    IOS = 'ios',
    WEB = 'web',
    DESKTOP = 'desktop',
    UNKNOWN = 'unknown'
}